import Icon from '../components/Icon.vue'

Icon.register({
  heartbeat: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M320.2 243.8l22.1 44.2h109.1l-182.6 186.5c-7.1 7.3-18.6 7.3-25.7 0l-182.5-186.5h94.1l30-71.7 56.9 126.3c5.5 12.3 22.9 12.7 28.9 0.6zM473.7 73.9c48.7 49.8 50.8 129.1 7.3 182.1h-118.9l-27.6-55.2c-5.9-11.8-22.7-11.8-28.6 0l-49 97.9-58.2-129.3c-5.8-12.8-24-12.5-29.4 0.4l-35.9 86.2h-102.4c-43.5-53-41.4-132.3 7.3-182.1l2.4-2.4c51.5-52.7 135.9-52.7 187.4 0l27.9 28.5 27.9-28.6c51.6-52.6 135.9-52.6 187.4 0z'
      }
    ]
  }
})
